import { render, staticRenderFns } from "./VsTableHeader.vue?vue&type=template&id=88ff73b2&lang=pug&"
import script from "./VsTableHeader.vue?vue&type=script&lang=js&"
export * from "./VsTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ff73b2')) {
      api.createRecord('88ff73b2', component.options)
    } else {
      api.reload('88ff73b2', component.options)
    }
    module.hot.accept("./VsTableHeader.vue?vue&type=template&id=88ff73b2&lang=pug&", function () {
      api.rerender('88ff73b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsTableHeader.vue"
export default component.exports